<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><router-link to="/kr/mypage/result/out">외래진료 내역</router-link></li>
            <!-- <li class="tab-menu__item"><router-link to="/kr/mypage/result/drug">약 처방 내역</router-link></li> -->
            <li class="tab-menu__item"><router-link to="/kr/mypage/result/check">검사 내역 조회</router-link></li>
        </ul>
    </div>
    <p class="bullet03">오늘날짜로부터 1년 이내의 내역만 보여지며, 아래 조건검색으로 검색을 통해 조회하실 수 있습니다.</p>
    <p class="bullet03">예약은 되었으나 실제 진료받지 못한 경우, 해당 내역은 조회되지 않습니다.</p>
    <div class="table-wrap">
        <div class="table-search">
            <VueDatePicker
            v-model="selectedDateRange"
            locale="ko"
            :format="customFormat"
            :enable-time-picker="false"
            week-start="0"
            position="left"
            placeholder="날짜를 선택하세요."
            auto-apply
            :range="true" :multi-calendars="true"
        />
            <ul class="table-select__button-wrap">
                <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 3}" @click="setSelectedPeriod(3)">3개월</a></li>
                <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 6}" @click="setSelectedPeriod(6)">6개월</a></li>
                <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 12}" @click="setSelectedPeriod(12)">12개월</a></li>
            </ul>
            <!-- <a href="javascript:;" class="main-button c-main" @click="getOutList">검색</a> -->
        </div>
        <div class="table scroll">
            <div class="table__inner">
                <table>
                    <colgroup>
                        <col style="width: 15%;">
                        <col style="width: 35%;">
                        <col style="width: 35%;">
                        <col style="width: 15%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>진료일자</th>
                            <th>진료과</th>
                            <th>진료의</th>
                            <th>다시예약</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="$commonUtils.isEmpty(outList)">
                            <td colspan="4">검색된 내용이 없습니다.</td>
                        </tr>
                        <tr v-for="out in outList">
                            <td>{{out.MED_DT}}</td>
                            <td class="left">{{out.DEPT_NM}}</td>
                            <td class="left">{{out.MEDR_NM}}</td>
                            <td>
                                <div class="botton-wrap">
                                    <a href="javascript:;" class="main-button small c-gray" @click="againReservation(out)">다시예약</a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <kr_popup_certification v-if="popupVisible" @cancelNameCheck="hidePopup"/>
    <kr_popup_reserve @successReservation="successReservation" ref="popupReserve"/>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    components: {
        VueDatePicker,
  },
   data() {
        return {
            selectedDateRange: [new Date(), new Date()],
            selectedPeriod: 3,
            customFormat: 'yyyy-MM-dd',
            outList: [],
            popupVisible: false,
        };
    },
    mounted() {
        if(this.$commonUtils.isEmpty(this.$store.state.myInfoStore.ptNo)){
            this.$store.commit('setNiceType', '')
            this.popupVisible = true

            window.addEventListener("message", (event) => {
                try {

                    if (event.data && event.data.source === "react-devtools-content-script") {
                        return;
                    }

                    const receivedData = JSON.parse(event.data); // JSON 파싱
                    if (receivedData.callFunction === "checkSuccess") {
                        this.checkSuccess(receivedData.data); // 데이터 전달
                    }
                } catch (e) {
                    console.error("Invalid JSON data received:", e);
                }
            });
        }else{
            this.setSelectedPeriod(12)
        }
    },
    methods: {
        showPopup() {
            this.popupVisible = true;
        },
        hidePopup() {
            this.popupVisible = false;
            this.$router.push('/kr/mypage/mypage')
        },
        checkSuccess(data){
            if(data.iReturn === 0 && data.ptNo !== '' && data.ptNo !== null){
                // this.hidePopup()
                this.popupVisible = false;
                this.axios.get(this.api.member.info)
                    .then(res => {
                        if(res.data.ptNo) this.$store.state.myInfoStore.ptNo = res.data.ptNo;
                        this.setSelectedPeriod(12)
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }else{
                alert(data.sMessage)
            }
        },
        setSelectedPeriod(months) {
            const startDate = new Date()
            const endDate = new Date()
            startDate.setMonth(endDate.getMonth() - months)
            this.selectedDateRange = [startDate, endDate]
            this.selectedPeriod = months
            this.getOutList()
        },
        getOutList() {
            const searchParam = {
                IN_FROM_DT: this.$commonUtils.timestampToDateFormate(this.selectedDateRange[0], 'yyyyMMdd', ''),
                IN_TO_DT: this.$commonUtils.timestampToDateFormate(this.selectedDateRange[1], 'yyyyMMdd', '')
            }

            this.axios.get(this.api.mypage.outList, {
                params: searchParam
            }).then(res => {
                this.outList = res.data.list
            })
        },
        againReservation(item){
            this.$refs.popupReserve.info = item
            this.$refs.popupReserve.popupBtn()
        },
        successReservation(){
            this.$router.push('/kr/mypage/reservation/selectReservation')
        },
    }
};
</script>

<style scoped></style>